export default "__VITE_ASSET__89f4013f__"